(function (){
	"use strict";
	/*	UI.EXPANDCOLLAPSE ---------------------------------------------------------------------
		adds behaviours to expand & collapse an associated target
	*/
	var ExpandCollapse = (function(){
		
		var $triggers = $('.exp-col'),
		
		init = function() {

			$triggers.on('click', function(){
				
				if( $(this).hasClass('collapsed') ) {
					
					$(this).removeClass('collapsed');
					$('#' + $(this).data('target')).removeClass('collapsed');
					
				}
				else {
					
					$(this).addClass('collapsed');
					$( '#' + $(this).data('target') ).addClass('collapsed');
					
				}
				
				return false;
				
			});
			
		};
		
		return { init: init };
		
	}());
	$(document).ready(function(){
		ExpandCollapse.init();
	});
}());